import React from 'react';
import glamorous from 'glamorous';

import { media, font } from '../../styles';
import { propTypes, defaultProps } from './types';

export const rules = {
  fontWeight: 300,
  fontSize: font.getFontSize(1),
  lineHeight: font.getLineHeight(1.25),

  [media('sm')]: {
    lineHeight: font.getLineHeight(1.375),
  },
};

const style = props => ({
  ...rules,
  textAlign: props.align,
  fontWeight: props.weight,
  marginBottom: props.marginBottom,
  marginTop: props.marginTop,
  fontSize: props.fontSize,
  ...props.glamStyle,
});

const baseStyle = style({});
const P = glamorous.p(baseStyle, style);

class Body extends React.PureComponent {
  static propTypes = propTypes;
  static defaultProps = defaultProps;

  render() {
    const {
      children,
      style,
      ...rest,
    } = this.props;

    return (
      <P {...rest} glamStyle={style}>
        {children}
      </P>
    );
  }
}

export default Body;



// WEBPACK FOOTER //
// ./src/components/typography/Body.js